import { LRS_BASE_URL, LRS_PASSWORD, LRS_USERNAME } from './constant';

const VALUES_PREFIX = 'https://api.zanichelli.it/xapi';

const getStatementPayloadBase = (verb: string, advId: number, advDescription?: string, userId?: string) => {
  const statementPayload = {
    verb: {
      id: `${VALUES_PREFIX}/verbs/${verb}`,
    },
    context: {
      platform: 'adv',
      extensions: {
        'https://api.zanichelli.it/xapi/keys/referer/id': `${advId}`,
      },
      contextActivities: {
        parent: [
          {
            id: window.location.origin,
          },
        ],
      },
    },
    object: {
      objectType: 'Activity',
    },
    actor: {
      objectType: 'Agent',
      account: {
        homePage: 'https://adv.zanichelli.it',
        name: userId ?? 'anonymous',
      },
    },
    timestamp: new Date().toISOString(),
    version: '1.0.0',
    authority: {
      name: 'Zanichelli',
      mbox: 'mailto:info@Zanichelli.it',
    },
  };

  if (advDescription) {
    statementPayload.context.extensions['https://api.zanichelli.it/xapi/keys/referer/description'] = advDescription;
  }

  return statementPayload;
};

const sendStatement = async payload => {
  const headers = new Headers();
  headers.set('Authorization', 'Basic ' + window.btoa(LRS_USERNAME + ':' + LRS_PASSWORD));
  headers.set('Content-Type', 'application/json');

  return await fetch(`${LRS_BASE_URL}/data/xAPI/statements`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
};

export const sendFocusedXapi = async (advId: number, focusedUrl: string, advDescription?: string, userId?: string) => {
  const statementPayloadBase = getStatementPayloadBase('focused', advId, advDescription, userId);
  const payload = {
    ...statementPayloadBase,
    object: {
      ...statementPayloadBase.object,
      id: focusedUrl,
    },
  };

  return await sendStatement(payload);
};

export const sendClosedXapi = async (advId: number, doNotShowAgain: boolean, advDescription?: string, userId?: string) => {
  const statementPayloadBase = getStatementPayloadBase('closed', advId, advDescription, userId);
  const payload = {
    ...statementPayloadBase,
    object: {
      ...statementPayloadBase.object,
      id: 'https://adv.zanichelli.it',
      definition: {
        extensions: {
          [`${VALUES_PREFIX}/doNotShowAgain`]: doNotShowAgain,
        },
      },
    },
  };

  return await sendStatement(payload);
};
